const appVer = `v2.9.6.20`;

import {createApp} from 'vue'
import App from './App.vue'
import AddToHomescreen from '@owliehq/vue-addtohomescreen';
import './registerServiceWorker'
import router from './router'
import store from './store'

import Q from 'q'
import _ from 'lodash'
import axios from "axios"
import {DateTime} from "luxon";
import ApexCharts from 'apexcharts';

import shortNumber from 'short-number';

import VueViewer from 'v-viewer';

import {createVfm} from 'vue-final-modal';
import {library} from '@fortawesome/fontawesome-svg-core'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import {fas} from '@fortawesome/free-solid-svg-icons';
import {far} from '@fortawesome/free-regular-svg-icons';
import {fab} from '@fortawesome/free-brands-svg-icons';
import Vue3FormWizard from 'vue3-form-wizard'
import Vue3EasyDataTable from 'vue3-easy-data-table';
import Datepicker from 'vuejs3-datepicker';


import 'vue3-form-wizard/dist/style.css'
import 'bulma-checkbox/css/main.min.css'
import 'bulma-radio/css/main.min.css'
import 'vue3-easy-data-table/dist/style.css';
import 'vue-final-modal/style.css'

const format = require('format-number');


library.add(fas, far, fab);


require('./styles/bulma-styles.scss');
require('./styles/fancy-check-radios.scss');
require('./styles/pictureInputSliders.scss');
require('flag-icons/css/flag-icons.min.css');

require('viewerjs/dist/viewer.css');

require('./styles/preview-checkbox.css');
require('./styles/thumbs-up.css');
require('./styles/progress-overlay.scss');
require('./styles/switch-button.scss');
require('./styles/safeapp.css');

if (location.host === 'safeapp.myamh.org') {
    axios.defaults.baseURL = 'https://safeappnode.myamh.org';
} else {
    axios.defaults.baseURL = 'https://safedevnode.myamh.org';
}

axios.interceptors.request.use(function (config) {
    config.headers.appVer = appVer;
    return config
});

const vfm = createVfm();


createApp(App)
    .mixin({
        data() {
            return {}
        },
        methods: {
            async manageDirtyList(action, caseId) {
                let vm = this,
                    caseData = _.split(caseId, '_'),
                    patientStore,
                    storeCaseId;
                switch (action) {
                    case 'dirty':
                        if (!_.indexOf(vm.localDirtyList, caseId) >= 0) {
                            switch (caseData[0]) {
                                case 'draftProfile':
                                    patientStore = 'draftProfiles';
                                    storeCaseId = vm.patientProfileIdentifier
                                    break;
                                case 'returnedProfile':
                                    patientStore = 'returnedProfiles';
                                    storeCaseId = caseData[1]
                                    break;
                            }
                            let targetPatient = await vm.getPatientFromDb(vm.IDB, patientStore, storeCaseId, 'caseId', false);
                            await vm.putPatientToDb(vm.IDB, patientStore, _.assignIn({}, targetPatient[0], {dirtyState: true}));
                            vm.localDirtyList.push(caseId)
                            vm.localDirtyList = _.uniq(vm.localDirtyList);

                            switch (caseData[0]) {
                                case 'draftProfile':
                                    vm.draftProfiles = await vm.fetchFromIDB('draftProfiles');
                                    break;
                                case 'returnedProfile':
                                    vm.returnedProfiles = await vm.fetchFromIDB('returnedProfiles');
                                    break;
                            }
                        }
                        break;
                }
                vm.$emit('dirtLists', {
                    dirtyList: _.uniq(_.compact(vm.localDirtyList))
                });
            },
            createStore: function (db, storeName) {
                if (!db.objectStoreNames.contains(storeName)) {
                    db.createObjectStore(storeName, {
                        keyPath: 'id'
                    });
                } else {
                    db.deleteObjectStore(storeName);
                    db.createObjectStore(storeName, {
                        keyPath: 'id'
                    });
                }
            },
            createIndex: function (req, storeName, indexDetails) {
                let trans = req.transaction;
                let store = trans.objectStore(storeName);
                _.forEach(indexDetails, function (indexDetail) {
                    if (!store.indexNames.contains(indexDetail.indexName)) {
                        store.createIndex(indexDetail.indexName, indexDetail.indexName, {unique: indexDetail.indexUnique});
                    }
                });
            },
            getIDB: async function () {
                let vm = this;
                return new Promise(function (resolve, reject) {
                    let appVerParts = _.split(appVer, '.');
                    let DBVersion = parseInt(appVerParts[appVerParts.length - 1]);
                    let request = window.indexedDB.open('safeApp-db', DBVersion);
                    request.onerror = function (e) {
                        console.error('Error opening db', e);
                        reject('Error');
                    };
                    request.onsuccess = function (e) {
                        let db = e.target.result;
                        resolve(db);
                    };
                    request.onupgradeneeded = function (e) {
                        let req = e.target;
                        let db = e.target.result;

                        vm.createStore(db, 'draftProfiles');
                        vm.createStore(db, 'unapprovedProfiles');
                        vm.createStore(db, 'approvedProfiles');
                        vm.createStore(db, 'returnedProfiles');
                        vm.createStore(db, 'rejectedProfiles');

                        vm.createStore(db, 'draftFeedbacks');
                        vm.createStore(db, 'unapprovedFeedbacks');
                        vm.createStore(db, 'returnedFeedbacks');
                        vm.createStore(db, 'closedFeedbacks');
                        vm.createStore(db, 'invoiceFeedbacks');
                        vm.createStore(db, 'remittanceFeedbacks');


                        vm.createIndex(req, 'draftProfiles', [
                            {indexName: 'caseId', indexUnique: true},
                            {indexName: 'dirtyState', indexUnique: false},
                            {indexName: 'partnerId', indexUnique: false}
                        ]);

                        vm.createIndex(req, 'unapprovedProfiles', [
                            {indexName: 'caseId', indexUnique: true},
                            {indexName: 'dirtyState', indexUnique: false},
                            {indexName: 'partnerId', indexUnique: false}
                        ]);

                        vm.createIndex(req, 'approvedProfiles', [
                            {indexName: 'caseId', indexUnique: true},
                            {indexName: 'dirtyState', indexUnique: false},
                            {indexName: 'partnerId', indexUnique: false}
                        ]);

                        vm.createIndex(req, 'returnedProfiles', [
                            {indexName: 'caseId', indexUnique: true},
                            {indexName: 'dirtyState', indexUnique: false},
                            {indexName: 'partnerId', indexUnique: false}
                        ]);

                        vm.createIndex(req, 'rejectedProfiles', [
                            {indexName: 'caseId', indexUnique: true},
                            {indexName: 'dirtyState', indexUnique: false},
                            {indexName: 'partnerId', indexUnique: false}
                        ]);

                        vm.createIndex(req, 'draftFeedbacks', [
                            {indexName: 'caseId', indexUnique: true},
                            {indexName: 'dirtyState', indexUnique: false},
                            {indexName: 'partnerId', indexUnique: false}
                        ]);

                        vm.createIndex(req, 'unapprovedFeedbacks', [
                            {indexName: 'caseId', indexUnique: true},
                            {indexName: 'dirtyState', indexUnique: false},
                            {indexName: 'partnerId', indexUnique: false}
                        ]);

                        vm.createIndex(req, 'returnedFeedbacks', [
                            {indexName: 'caseId', indexUnique: true},
                            {indexName: 'dirtyState', indexUnique: false},
                            {indexName: 'partnerId', indexUnique: false}
                        ]);

                        vm.createIndex(req, 'closedFeedbacks', [
                            {indexName: 'caseId', indexUnique: true},
                            {indexName: 'dirtyState', indexUnique: false},
                            {indexName: 'partnerId', indexUnique: false}
                        ]);

                        vm.createIndex(req, 'invoiceFeedbacks', [
                            {indexName: 'caseId', indexUnique: true},
                            {indexName: 'dirtyState', indexUnique: false},
                            {indexName: 'partnerId', indexUnique: false}
                        ]);

                        vm.createIndex(req, 'remittanceFeedbacks', [
                            {indexName: 'caseId', indexUnique: true},
                            {indexName: 'dirtyState', indexUnique: false},
                            {indexName: 'partnerId', indexUnique: false}
                        ]);
                    };
                });
            },
            addPatientToDb: async function (IDB, patientStore, patientData) {
                let vm = this;
                return new Promise(function (resolve, reject) {
                    if (!IDB.objectStoreNames.contains(patientStore)) {
                        vm.createStore(IDB, patientStore);
                        resolve();
                    } else {
                        let trans = IDB.transaction([patientStore], 'readwrite');
                        trans.oncomplete = function () {
                            resolve();
                        };
                        trans.onerror = function (e) {
                            if (e.target.error === 'ConstraintError: Key already exists in the object store.') {
                                console.error(`duplicate patient: ${JSON.stringify(patientData)}`);
                                resolve();
                            } else {
                                console.error('Error adding patient to db', e);
                                console.error(e.target);
                                console.error(e.target.error);
                                console.error(patientData);
                                reject('Error');
                            }

                        };
                        let store = trans.objectStore(patientStore);
                        if (typeof patientData !== 'undefined') {
                            let request = store.add(patientData);
                            request.onerror = function (e) {
                                console.error('Error', e.target.error.name);
                                console.error(patientData);
                            };
                            request.onsuccess = function () {
                            };
                        } else {
                            resolve();
                        }
                    }
                });
            },
            putPatientToDb: async function (IDB, patientStore, patientData) {
                return new Promise(function (resolve, reject) {
                    let trans = IDB.transaction([patientStore], 'readwrite');
                    trans.oncomplete = function () {
                        resolve();
                    };
                    trans.onerror = function (e) {
                        console.error('Error opening db', e);
                        reject('Error');
                    };
                    let store = trans.objectStore(patientStore);
                    let request = store.put(patientData);
                    request.onerror = function (e) {
                        console.error('Error', e.target.error.name);
                    };
                    request.onsuccess = function () {
                    };
                });
            },
            clearPatientsFromDb: async function (IDB, patientStore) {
                let vm = this;
                return new Promise(function (resolve, reject) {
                    if (!IDB.objectStoreNames.contains(patientStore)) {
                        vm.createStore(IDB, patientStore);
                        resolve();
                    } else {
                        let trans = IDB.transaction([patientStore], 'readwrite');
                        trans.oncomplete = function () {
                            resolve();
                        };
                        trans.onerror = function (e) {
                            console.error('Error opening db', e);
                            reject('Error');
                        };
                        let store = trans.objectStore(patientStore);
                        let request = store.clear();
                        request.onerror = function (e) {
                            console.error('Error', e.target.error.name);
                        };
                        request.onsuccess = function () {
                        };
                    }
                });
            },
            clearAllDbStores: async function (IDB) {
                let vm = this;
                return new Promise(function (resolve) {
                    _.forEach(IDB.objectStoreNames, async function (patientStore) {
                        await vm.clearPatientsFromDb(IDB, patientStore);
                    });
                    resolve();

                });
            },
            getPatientFromDb: async function (IDB, patientStore, patientKey, useIndex, recordsKey) {
                return new Promise(function (resolve, reject) {
                    let trans = IDB.transaction([patientStore], 'readwrite'),
                        patientData;
                    trans.oncomplete = function () {
                        resolve(patientData);
                    };
                    trans.onerror = function (e) {
                        console.error('Error opening db', e);
                        reject('Error');
                    };
                    let store;
                    if (useIndex) {
                        store = trans.objectStore(patientStore).index(useIndex);
                    } else {
                        store = trans.objectStore(patientStore);
                    }
                    let request;
                    if (patientKey) {
                        const keyRangeValue = IDBKeyRange.only(patientKey);
                        request = store.openCursor(keyRangeValue);
                    } else {
                        request = store.openCursor();
                    }


                    patientData = [];
                    request.onerror = function (e) {
                        console.error('Error', e.target.error.name);
                    };
                    request.onsuccess = (e) => {
                        let cursor = e.target.result,
                            patientDataObject;
                        if (cursor) {
                            patientDataObject = cursor.value;
                            if (recordsKey) {
                                patientData.push(_.assignIn({}, patientDataObject[recordsKey], {
                                    dirtyState: patientDataObject.dirtyState,
                                    partnerId: patientDataObject.partnerId,
                                }));
                            } else {
                                patientData.push(patientDataObject);
                            }
                            cursor.continue();
                        } else {
                            resolve(patientData);
                        }
                    };


                });
            },
            isoToJSDate: function (isoString) {

                let isoStringParts = _.split(isoString, 'T'),
                    isoStringTimeWithZone = _.split(isoStringParts[1], '+'),
                    isoStringTimeSeconds = _.split(isoStringTimeWithZone[0], '.');

                const isoStringPartsArr = _.split(isoStringParts[0], '-'),
                    isoStringTimeSecondsArr = _.split(isoStringTimeSeconds[0], ':');
                return new Date(isoStringPartsArr[0], parseInt(isoStringPartsArr[1]) - 1, isoStringPartsArr[2], isoStringTimeSecondsArr[0], isoStringTimeSecondsArr[1], isoStringTimeSecondsArr[2], isoStringTimeSeconds[1]);
            },
            fetchCaseDetails: function (fetchCaseDetailsFrom, caseId, currentDataToken, partnerId, caseYear) {
                return new Promise(function (resolve) {
                    axios.post(`/profile/caseView`, {
                        caseId: caseId,
                        fetchCaseDetailsFrom: fetchCaseDetailsFrom,
                        partnerId: partnerId,
                        caseYear: caseYear,
                    }, {
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: `Bearer ${currentDataToken}`
                        }
                    })
                        .then(function (res) {
                            resolve(res);
                        })
                        .catch(function (err) {
                            console.error(err);
                            resolve({});
                        });
                });

            }
        },
    })
    .use(vfm)
    .use(store)
    .use(router)
    .use(Vue3FormWizard)
    .use(VueViewer)
    .use(AddToHomescreen, {
        buttonColor: 'blue',
    })
    .component('font-awesome-icon', FontAwesomeIcon)
    .component('EasyDataTable', Vue3EasyDataTable)
    .component('Datepicker', Datepicker)
    .provide('$Q', Q)
    .provide('$_', _)
    .provide('$axios', axios)
    .provide('$formatNumber', format)
    .provide('$DateTime', DateTime)
    .provide('$ApexCharts', ApexCharts)
    .provide('$shortNumber', shortNumber)
    .provide('$appVer', appVer)
    .provide('$apiBaseURL', axios.defaults.baseURL)
    .mount('#app');
